import React from "react";

const ConditionLabel = ({ condition }) => {
  return (
    <>
      <div
        className={`text-white inline-block text-[0.9rem]  py-[3px] px-[20px]  rounded-full ${
          condition == "FOLYAMATBAN" ? "bg-[#b28d0a80]" : "bg-[#06556780]"
        }`}
      >
        {condition}
      </div>
    </>
  );
};

export default ConditionLabel;
